import React, { useEffect } from "react";
import { Box, Drawer, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { LinkList } from "../Components/";
import { IOption } from "../../app/types";
import { useAppSelector } from "../../app/hooks";

/* Functional component properties */
interface Props {
  classes: any;
  isOpen: boolean;
  handleDrawerToggle: () => void;
  optionClickHandler: (option: IOption) => void;
}

/* React Functional component */
export const SideBarRenderer: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  isOpen,
  handleDrawerToggle,
  optionClickHandler,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  useEffect(() => {
    if (
      (state.sidebar.optionsList.length === 0 && isOpen) ||
      (state.sidebar.optionsList.length > 0 && !isOpen)
    )
      handleDrawerToggle();
  }, [state.sidebar.optionsList]);

  return (
    <Drawer variant="persistent" open={isOpen} id="sidebar">
      {/* Leaving space on top to prevent overlapping with Topbar */}
      <div className={classes.toolbar} />

      {/* Icon to close the sidebar drawer */}
      <div className={classes.drawerHeader}>
        <IconButton
          onClick={handleDrawerToggle}
          className={classes.sidebarCollapseIcon}
        >
          <ChevronLeftIcon />
        </IconButton>
      </div>

      {/* Container for the sidebar components */}
      <Box className={classes.drawerContainer}>
        {/* Container for Options List */}
        <Box>
          {state.sidebar.optionsList.length ? (
            <LinkList
              classes={classes}
              header={"Links"}
              list={state.sidebar.optionsList}
              handler={optionClickHandler}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </Drawer>
  );
};
